import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=ea3bf8c6&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=ea3bf8c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3bf8c6",
  null
  
)

export default component.exports